import * as API from "@/services/API";
import { RecordIdentifier } from "@/data/global";

export default {
    getEnrollments() {
        return API.apiClient.get(`/user/enrollments`);
    },
    getEnrollmentsArchive() {
        return API.apiClient.get(`/user/enrollments/archive`);
    },
    getOrders() {
        return API.apiClient.get('/user/orders');
    },
    generateOrderInvoiceDownloadLink(orderId: RecordIdentifier) {
        return API.apiClient.post(`/user/orders/${orderId}/invoice`);
    },
}
